/**
 * Collection Subheader
 * - Mobile categories Swiper slider
 * - Product search bar with debounce, pagination, and empty state
 */
document.addEventListener('DOMContentLoaded', () => {
  /* ── Mobile Categories Swiper ── */
  const categoriesSlider = document.querySelector('.collection-subheader__categories--mobile');

  if (categoriesSlider) {
    new Swiper('.collection-subheader__categories--mobile', {
      slidesPerView: 'auto',
      spaceBetween: 4,
      freeMode: true,
      grabCursor: true,
      centeredSlides: false,
      slidesOffsetBefore: 0,
      slidesOffsetAfter: 0,
    });
  }

  /* ── Product Search Bar ── */
  const searchInput = document.getElementById('collection-search-input');
  if (!searchInput) return;

  let debounceTimer = null;

  searchInput.addEventListener('input', () => {
    clearTimeout(debounceTimer);
    debounceTimer = setTimeout(() => {
      performSearch(searchInput.value.trim().toLowerCase());
    }, 250);
  });

  /**
   * Routes the search to the correct handler based on grid type.
   */
  const performSearch = (term) => {
    const grid = document.getElementById('js-paginated-grid');
    const navContainer = document.getElementById('js-pagination-nav');

    if (grid) {
      searchJsPaginated(grid, navContainer, term);
    } else {
      searchStandard(term);
    }
  };

  /**
   * Filters JS-paginated items by title, shows page 1 of results,
   * and rebuilds pagination controls.
   */
  const searchJsPaginated = (grid, navContainer, term) => {
    const allItems = [...grid.querySelectorAll('.js-paginated-item')];
    const perPage = parseInt(grid.getAttribute('data-per-page'), 10) || 12;

    const matchingItems = allItems.filter((item) => {
      const titleEl = item.querySelector('.product-card-custom__title');
      const title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';
      return !term || title.includes(term);
    });

    // Hide everything, then show page 1 of matches
    allItems.forEach((item) => { item.style.display = 'none'; });

    const totalPages = Math.max(1, Math.ceil(matchingItems.length / perPage));
    const end = Math.min(perPage, matchingItems.length);

    matchingItems.forEach((item, i) => {
      item.style.display = i < end ? '' : 'none';
    });

    // Update pagination
    if (navContainer) {
      if (matchingItems.length === 0 || totalPages <= 1) {
        navContainer.innerHTML = '';
      } else {
        buildSearchPagination(navContainer, matchingItems, perPage, 1, totalPages);
      }
    }

    toggleEmptyMessage(grid, matchingItems.length === 0);
  };

  /**
   * Builds pagination controls for search results and binds click events.
   */
  const buildSearchPagination = (navContainer, matchingItems, perPage, currentPage, totalPages) => {
    const prevArrow = currentPage > 1
      ? `<a href="#" class="pagination__link pagination__link--arrow" data-search-page="${currentPage - 1}">‹</a>`
      : `<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-disabled="true">‹</span>`;

    const nextArrow = currentPage < totalPages
      ? `<a href="#" class="pagination__link pagination__link--arrow" data-search-page="${currentPage + 1}">›</a>`
      : `<span class="pagination__link pagination__link--arrow pagination__link--disabled" aria-disabled="true">›</span>`;

    const pageLinks = Array.from({ length: totalPages }, (_, i) => {
      const page = i + 1;
      const link = page === currentPage
        ? `<span class="pagination__link pagination__link--page pagination__link--current" aria-current="page">${page}</span>`
        : `<a href="#" class="pagination__link pagination__link--page" data-search-page="${page}">${page}</a>`;
      return `<li class="pagination__item">${link}</li>`;
    }).join('');

    navContainer.innerHTML = `
      <nav class="pagination" aria-label="Pagination">
        <ul class="pagination__list" role="list">
          <li class="pagination__item">${prevArrow}</li>
          ${pageLinks}
          <li class="pagination__item">${nextArrow}</li>
        </ul>
      </nav>`;

    // Bind pagination click events
    navContainer.querySelectorAll('[data-search-page]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const page = parseInt(link.getAttribute('data-search-page'), 10);

        // Hide all items, then show the requested page of matches
        const allItems = [...(navContainer.closest('section')?.querySelectorAll('.js-paginated-item') ?? [])];
        allItems.forEach((item) => { item.style.display = 'none'; });

        const start = (page - 1) * perPage;
        const end = start + perPage;
        matchingItems.forEach((item, i) => {
          item.style.display = (i >= start && i < end) ? '' : 'none';
        });

        buildSearchPagination(navContainer, matchingItems, perPage, page, totalPages);

        const grid = document.getElementById('js-paginated-grid');
        grid?.scrollIntoView({ behavior: 'smooth', block: 'start' });
      });
    });
  };

  /**
   * Fallback search for standard server-paginated grids.
   */
  const searchStandard = (term) => {
    const grid = document.querySelector('.collection-products__grid');
    if (!grid) return;

    const items = [...grid.querySelectorAll('.collection-products__item')];
    let visibleCount = 0;

    items.forEach((item) => {
      const titleEl = item.querySelector('.product-card-custom__title');
      const title = titleEl ? titleEl.textContent.trim().toLowerCase() : '';

      if (!term || title.includes(term)) {
        item.style.display = '';
        visibleCount++;
      } else {
        item.style.display = 'none';
      }
    });

    toggleEmptyMessage(grid, visibleCount === 0);
  };

  /**
   * Shows or hides the "No products found" message.
   */
  const toggleEmptyMessage = (grid, show) => {
    const parent = grid.parentElement;
    let emptyMsg = parent.querySelector('.collection-products__search-empty');

    if (show) {
      if (!emptyMsg) {
        emptyMsg = document.createElement('p');
        emptyMsg.className = 'collection-products__empty collection-products__search-empty';
        emptyMsg.textContent = 'No products found';
        parent.insertBefore(emptyMsg, grid.nextSibling);
      }
      emptyMsg.style.display = '';
    } else if (emptyMsg) {
      emptyMsg.style.display = 'none';
    }
  };
});
